/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

/* Components */
import ScrollView from '../ScrollView';

function ChannelsContainer({
  className,
  style,
  scrollableStyle,
  onScroll,
  children,
  initialScrollPosition,
}) {
  return (
    <ScrollView
      className={`dtv-html5-c-epg__channels-container ${className}`}
      onScroll={onScroll}
      scrollableStyle={scrollableStyle}
      style={style}
      initialScrollPosition={initialScrollPosition}
    >
      {children}
    </ScrollView>
  );
}

ChannelsContainer.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  scrollableStyle: PropTypes.shape({}),
  onScroll: PropTypes.func,
  children: PropTypes.node.isRequired,
  initialScrollPosition: PropTypes.number,
};

ChannelsContainer.defaultProps = {
  className: '',
  style: undefined,
  scrollableStyle: undefined,
  onScroll: undefined,
  initialScrollPosition: 0,
};

export default memo(withFocusable()(memo(ChannelsContainer)));
